import { gql } from '@apollo/client';

const ADD_FIGURE = gql`mutation addFigure($versionId:Int!, $figureData:String){
	
	resourceComments{
		addFigure(resourceVersionId:$versionId, figureData:$figureData)
		{
			author
			avatarUrl
			connectedCommentId
			created
			figureData
			id
			resourceVersionId
			userId
		}
	}
}

`;

export default ADD_FIGURE;
